import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/searchengin': {
    width: 460,
    height: 512,
    paths: [
      {
        d: 'M220.6 130.3L153.4 158.5V43.2L98.7 233.5 153.4 209.3V339.6L220.6 130.3zM137.4 33.6L136.1 38.3 120.9 91.2C80.6 106.7 52 145.8 52 191.5 52 243.8 86.3 287.4 135.4 297V350.6C57.5 340.1 0 272.4 0 191.6 0 111.1 59.8 44.4 137.4 33.6zM448.8 480.8C437.6 492 425.7 493.1 420.2 491.3 414.8 489.5 393.1 471.4 359.8 446.9 326.5 422.3 326.2 411.2 316.8 390.2 307.4 369.3 286.4 347.6 259.3 337.8L249.6 323.1C224.9 340 196.6 350 168.3 351.8L170.4 345.2 186.3 295.7C232.8 283.8 267.2 241.7 267.2 191.5 267.2 137 228.8 89.4 171.2 84.4V32.3C254.4 37.4 320 106.8 320 191.6 320 225.2 308.8 256.3 291 282L305.6 291.6C315.4 318.7 337.1 339.6 358 349S390.2 358.7 414.8 392C439.4 425.2 457.5 446.9 459.3 452.3S460 469.6 448.8 480.8zM438.9 462.9C438.9 458.5 435.3 454.9 430.9 454.9S422.9 458.5 422.9 462.9 426.5 470.9 430.9 470.9 438.9 467.3 438.9 462.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/searchengin.js
// module id = vRJ7
// module chunks = 144